import { useEffect, useState } from "react";
import {
  useOrganizationList,
  useClerk,
  useOrganization,
} from "@clerk/clerk-react";
import { Select, Button, Avatar, Divider, Badge, message } from "antd";
import {
  TeamOutlined,
  UserOutlined,
  PlusOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useModalStore } from "../../hooks/useModalStore";

function CustomOrganizationSwitcher() {
  const { setShowCreateOrg, setShowManageOrg } = useModalStore();
  const { setActive, user } = useClerk();
  const { organization, membership } = useOrganization();

  const [currentOrg, setCurrentOrg] = useState<any>(null);
  const [orgListOptions, setOrgListOptions] = useState<any[]>([]);

  const { userMemberships, userInvitations, userSuggestions } =
    useOrganizationList({
      userMemberships: {
        infinite: true,
        pageSize: 500,
      },
      userInvitations: {
        infinite: true,
        pageSize: 500,
      },
      userSuggestions: {
        infinite: true,
        pageSize: 500,
      },
    });

  const refreshOrgList = () => {
    const allOrganizationMemberships = user?.organizationMemberships || [];
    // console.log("user", user);
    // console.log("allOrganizationMemberships", allOrganizationMemberships);
    // console.log("userMemberships", userMemberships);
    // console.log("userInvitations", userInvitations);
    // console.log("userSuggestions", userSuggestions);

    const options = [
      // {
      //   value: null,
      //   label: "个人账户",
      //   icon: <UserOutlined className="text-gray-500" />,
      // },
      ...(allOrganizationMemberships
        ?.map((membership) => ({
          value: membership.organization.id,
          label: membership.organization.name,
          icon: membership.organization.imageUrl ? (
            <Avatar
              size={32}
              shape="square"
              src={membership.organization.imageUrl}
              className="rounded"
            />
          ) : (
            <TeamOutlined className="text-gray-500 text-xl" />
          ),
        }))
        ?.reverse() || []),
    ];
    setCurrentOrg(options.find((opt) => opt.value === organization?.id));
    setOrgListOptions(options);
  };

  useEffect(() => {
    refreshOrgList();
  }, [userInvitations?.data?.length]);

  const handleSwitch = (organizationId: string | null) => {
    setActive({ organization: organizationId });
    // 切换后 回到首页
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  };

  return (
    <Badge count={userInvitations?.data?.length} color="#552eef">
      <Select
        defaultActiveFirstOption={false}
        className="w-[200px]"
        value={organization?.id || null}
        onChange={handleSwitch}
        options={orgListOptions}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        dropdownRender={(menu) => (
          <div className="relative">
            {/* 当前组织 */}
            <OrganizationComponent
              currentOrg={currentOrg}
              membership={membership}
              setShowManageOrg={setShowManageOrg}
            />
            {/*  */}
            {/* 邀请列表 */}
            {userInvitations?.data?.map((invitation) => (
              <InviteItemComponent
                key={invitation.id}
                invitation={invitation}
                userMemberships={userMemberships}
                userInvitations={userInvitations}
                userSuggestions={userSuggestions}
                refreshOrgList={refreshOrgList}
              />
            ))}
            <div className="bg-white rounded-md shadow-md mt-1">
              {/* 组织列表选择器 */}
              {menu}
              {/* 功能区域 */}
              <Divider className="mt-2 mb-0" />
              <div className="">
                <div
                  className="flex h-[60px] items-center gap-2 p-2 rounded-md cursor-pointer hover:bg-gray-50"
                  onClick={() => setShowCreateOrg(true)}
                >
                  <PlusOutlined className="text-gray-500" />
                  <span className="text-gray-700">Create organization</span>
                </div>
              </div>
            </div>
          </div>
        )}
        //
        optionRender={(option) => (
          <div className="flex items-center gap-2 min-w-0 py-3">
            <span className="text-gray-700 text-xl flex-shrink-0">
              {option.data.icon}
            </span>
            <span className="text-gray-700 truncate">{option.data.label}</span>
          </div>
        )}
        labelRender={(option) => {
          const currentOrg: any =
            orgListOptions.find((opt) => opt.value === option.value) || {};
          // console.log("currentOrg", currentOrg);
          const currentOrgIconUrl = currentOrg?.icon?.props?.src;
          return (
            <div className="flex items-center gap-2">
              <span className="text-gray-700 text-sm flex-shrink-0 ml-1">
                {currentOrgIconUrl ? (
                  <Avatar
                    size={24}
                    shape="square"
                    src={currentOrgIconUrl}
                    className="rounded"
                  />
                ) : (
                  <TeamOutlined className="text-gray-500 text-xl" />
                )}
              </span>
              <span className="text-gray-700 truncate">
                {currentOrg?.label}
              </span>
              {/* <span className="text-gray-700 truncate">{option.value}</span> */}
            </div>
          );
        }}
      />
    </Badge>
  );
}

export default CustomOrganizationSwitcher;

const InviteItemComponent = ({
  invitation,
  userMemberships,
  userInvitations,
  userSuggestions,
  refreshOrgList,
}: {
  invitation: any;
  userMemberships: any;
  userInvitations: any;
  userSuggestions: any;
  refreshOrgList: () => void;
}) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  return (
    <div
      className="flex items-center gap-2 p-2 rounded-md cursor"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <span className="text-gray-700 text-xl flex-shrink-0">
          <Avatar
            size={32}
            shape="square"
            src={invitation?.publicOrganizationData?.imageUrl}
            className="rounded"
          />
        </span>
        <div className="flex flex-col w-[160px]">
          <span className="text-gray-500 text-sm truncate">
            {invitation?.publicOrganizationData?.name || ""}
          </span>
          <span className="text-gray-700 truncate">
            {invitation?.publicOrganizationData?.role
              ? invitation?.publicOrganizationData.role
                  .replace("org:", "")
                  .charAt(0)
                  .toUpperCase() +
                invitation?.publicOrganizationData.role
                  .replace("org:", "")
                  .slice(1)
              : ""}{" "}
            <span className="text-gray-500 text-sm">inviting</span>
          </span>
        </div>
      </div>
      {invitation?.accept && (
        <Button
          loading={buttonLoading}
          type="text"
          size="small"
          className="border border-gray-300 rounded-md"
          onClick={async (e) => {
            e.stopPropagation();
            // 列表里面带着 accept 方法
            try {
              setButtonLoading(true);
              const res = await invitation.accept();
              // console.log("res", res);
              if (res?.status === "accepted") {
                message.success("Successfully joined the organization");
              }
            } catch (error) {
              message.error("Failed to join the organization");
            } finally {
              setButtonLoading(false);
            }
            //
            userMemberships?.revalidate?.();
            userInvitations?.revalidate?.();
            userSuggestions?.revalidate?.();
            // setTimeout(() => {
            //   refreshOrgList();
            // }, 100);
          }}
        >
          Join
        </Button>
      )}
    </div>
  );
};

const OrganizationComponent = ({
  currentOrg,
  membership,
  setShowManageOrg,
}: {
  currentOrg: any;
  membership: any;
  setShowManageOrg: (show: boolean) => void;
}) => {
  return (
    <>
      <div
        className="flex items-center gap-2 p-2 rounded-md cursor"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <span className="text-gray-700 text-xl flex-shrink-0">
            {currentOrg?.icon}
          </span>
          <div className="flex flex-col w-[160px]">
            <span className="text-gray-500 text-sm truncate">
              {currentOrg?.label || ""}
            </span>
            <span className="flex items-center gap-2 text-gray-700 truncate">
              {membership?.role
                ? membership.role.replace("org:", "").charAt(0).toUpperCase() +
                  membership.role.replace("org:", "").slice(1)
                : ""}
              {
                <Button
                  type="text"
                  size="small"
                  className="border border-gray-300 rounded-md"
                  icon={<SettingOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowManageOrg(true);
                  }}
                >
                  Manage
                </Button>
              }
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
